import React                    from 'react';
import { connect }              from 'react-redux';
import { Dispatch }             from "redux";
import { reducerType }          from 'reducer';

import { ActionTypes }          from 'actions/types';
import Home                     from './home';
import Tirgul                   from './tirgul';
import Mazeget                  from './mazeget';
import Hidden                   from 'components/Hidden';
import { makeStyles }           from "makeStyles";
import { componentsStateType }  from 'reducer/types';
import { SET_COMPONENTS_STATE } from 'actions';

const useStyles = makeStyles()(
    () => ({
        root : {
            position:        'fixed',
            left:            0,
            minHeight:       '100vh',
            minWidth:        '100vw',
            maxHeight:       '100vh',
            maxWidth:        '100vw',
            alignItems:      'center',
            justifyContent:  'center',
            flexFlow:        'column',
            backgroundColor: '#FFF',
            overflowY:       'hidden',
            overflowX:       'hidden',
            transition:      'opacity 0.35s'
        }
    }),
);

type RootPropsType = {
  page:               string;
  componentsState:    componentsStateType;
  setComponentsState: (val: componentsStateType) => void;
}

const Root: React.FC<RootPropsType> = ({ page, componentsState, setComponentsState }) => {

    const { classes }               = useStyles();
    const [size, setSize]           = React.useState([0,0]);
    const [pageState, setPageState] = React.useState(componentsState.page);
    

    
    React.useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    const [menuSize, wideScreen] = React.useMemo(() => {
      const wide = size[0] > 1115 && size[1] > 560;
      return [(wide ? 210 : 0), wide]
   },[size])

   
    React.useEffect(() => {
    if ( page !==  pageState) {
      setPageState(page)
      setComponentsState({
        ...componentsState,
        animatePage: false
      })
    }
    
   },[componentsState, setComponentsState, page, pageState]) 


   const rootStyle = React.useMemo(() => {
     return{
       opacity: componentsState.animatePage ? 0 : 1
     }
   },[componentsState])


    return(
        <div 
           className = { classes.root }
           style     = { rootStyle }
        >
            <Hidden/>
            {
              page === 'home'
              &&
              <Home wideScreen = { wideScreen }/>
            }
            {
              page === 'tirgul'
              &&
              
                <Tirgul
                  size       = { size }
                  menuSize   = { menuSize }
                  wideScreen = { wideScreen }
                />
            }
            {
              page === 'mazeget'
              &&
              <Mazeget
                 size       = { size }
                 menuSize   = { menuSize }
                 wideScreen = { wideScreen }
              />
            }
        </div>
    )
}
  

const mapStateToProps = (reducer: reducerType) => {
  return {
    componentsState: reducer.components,
    page:            reducer.components.page,
}};
  
const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setComponentsState: (payload: componentsStateType) => dispatch(SET_COMPONENTS_STATE(payload)),
});
  
export default connect(mapStateToProps,mapDispatchToProps)(Root);
  
  
  
  
  
  
  



  //   http://eggapps.s3-website.us-east-2.amazonaws.com/


//   npm run build && aws s3 sync build/ s3://eggapps --delete
